import React from 'react';
import { Grid, TabPane, Form,  FormTextArea, Button } from 'semantic-ui-react';
import ReelAndContainerInput from './ReelAndContainerInput';

interface ContainerBarcode {
  container_barcode: string;
  reel_count: string;
  reel_barcode: string[];
}

interface FormValues {
  title: string;
  assetType: string;
  elementType: string;
  assetId: string;
  print: string;
  containerBarcodes: ContainerBarcode[];
  notes: string;
  [key: string]: string | ContainerBarcode[]; 

}

interface HFCPhysicalProps {
  formValues: FormValues;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, index: number) => void;
  handleTextAreaChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  setFormValues: React.Dispatch<React.SetStateAction<FormValues>>;
}

const HFCPhysical: React.FC<HFCPhysicalProps> = ({ formValues, handleInputChange, handleTextAreaChange, setFormValues,}) => {
  const handlePhysicalInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, idx: number) => {
    const updatedContainerBarcodes = [...formValues.containerBarcodes];
    const { name, value } = e.target;
  
    if (name === 'container_barcode') {
      updatedContainerBarcodes[idx].container_barcode = value;
    } else if (name === 'reel_count') {
      updatedContainerBarcodes[idx].reel_count = value;
    }
  
    const reelBarcodes = Array.from({ length: parseInt(updatedContainerBarcodes[idx].reel_count, 10) }, (_, i) =>
      `${updatedContainerBarcodes[idx].container_barcode}-${String(i + 1).padStart(2, '0')}`
    );
  
    updatedContainerBarcodes[idx].reel_barcode = reelBarcodes;
  
    setFormValues((prevState) => ({
      ...prevState,
      containerBarcodes: updatedContainerBarcodes,
    }));
  };

  const handleAddContainer = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setFormValues(prevState => ({
      ...prevState,
      containerBarcodes: [
        ...prevState.containerBarcodes,
        {
          container_barcode: '',
          reel_count: '0',
          reel_barcode: []
        }
      ]
    }));
  };

  return (
    <TabPane>
      <Form>
        {formValues.containerBarcodes.map((container, index) => (
          <ReelAndContainerInput
            key={index}
            index={index}
            reelCount={parseInt(container.reel_count)}
            onContainerBarcodeChange={handlePhysicalInputChange}
            onReelCountChange={handlePhysicalInputChange}
            handleAddContainer={handleAddContainer}
            formValues={formValues}
            setFormValues={setFormValues}
          />
        ))}
        <Grid>
          <Grid.Column>
            <Button primary onClick={handleAddContainer} style={{ width: '150px', marginTop: '10px' }}>Add Container</Button>
          </Grid.Column>
        </Grid>
        <Grid stretched columns={1}>
          <Grid.Column>
            <Form.Field>
              <FormTextArea label='Notes' placeholder='Notes...' name="notes" value={formValues.notes} onChange={handleTextAreaChange} />
            </Form.Field>
          </Grid.Column>
        </Grid>
      </Form>
    </TabPane>
  );
}

export default HFCPhysical;
